import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import UI from "@mile-meeting/mile-ui";
import ToolTip from "uis/new-tootip";
import AlertModal from "uis/modal/alert-modal";
import { getPricePlan } from "apis/workspace/pricing-plan";

interface TabletUsageFieldProps {
  isTabletExternalUsage?: boolean;
  isTabletInternalUsage?: boolean;
  onClickToggle?: () => void;
}

const TabletUsageField: React.FC<TabletUsageFieldProps> = ({
  isTabletExternalUsage,
  isTabletInternalUsage,
  onClickToggle,
}) => {
  const [isOpenAlert, setIsOpenAlert] = useState(false);
  const [enableTabletUsage, setEnableTabletUsage] = useState(false);

  useEffect(() => {
    getPricePlan("MEETING").then((res) => {
      if (res.data?.plan === 2) {
        setEnableTabletUsage(true);
      }
    });
  }, []);

  return (
    <Container>
      <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
        태블릿 사용
      </UI.Typography>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <LabelContainer>
          <UI.Icon name="tablet" size={24} color="var(--alias-color-label-normal)" />
          <UI.Typography type="body01 normal" fontStyle="medium">
            회의실 내 태블릿 사용 여부
          </UI.Typography>
          <ToolTip
            position={{
              top: 24,
              left: -220,
            }}
            icon="info"
            text={
              <p>
                회의실에서 태블릿을 사용하기 위해서는 해당 항목을 켜주셔야 합니다.
                <br />
                '태블릿 전용' 기능 역시 태블릿을 사용 중인 회의실이 최소 1개 이상 존재해야 활성화 가능합니다.
              </p>
            }
          />
        </LabelContainer>
        <RightContainer>
          <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-alternative)">
            {isTabletInternalUsage && isTabletExternalUsage
              ? "내부, 외부 태블릿 사용 중"
              : isTabletInternalUsage
                ? "내부 태블릿 사용 중"
                : isTabletExternalUsage
                  ? "외부 태블릿 사용 중"
                  : ""}
          </UI.Typography>
          <UI.Selection.Toggle.Default
            size="medium"
            onChange={() => {
              if (!enableTabletUsage) {
                setIsOpenAlert(true);
                return;
              } else onClickToggle?.();
            }}
            state={isTabletInternalUsage || isTabletExternalUsage}
          />
        </RightContainer>
      </div>
      <AlertModal
        modalIsOpen={isOpenAlert}
        closeModal={() => setIsOpenAlert(false)}
        onChange={() => {
          window.open("https://mile.channel.io/home");
        }}
        content={"사용을 원하시면 문의 부탁드립니다."}
        btnTitle="태블릿 사용 플랜 문의하기"
        title="이용 중이신 플랜에서는 태블릿 사용이 불가합니다."
      />
    </Container>
  );
};

export default React.memo(TabletUsageField);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const RightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
